module.exports = __webpack_public_path__ + "static/media/product-1.9e1c1908.png";